import { create } from 'zustand';

interface RebrandingStore {
  enableRebranding: boolean;
  setEnableRebranding: (enableRebranding: boolean) => void;
}

const initialState = {
  enableRebranding: false
};

export const useRebrandingStore = create<RebrandingStore>()((set) => ({
  ...initialState,
  setEnableRebranding: (enableRebranding: boolean) => set(() => ({ enableRebranding }))
}));
